<template>
  <q-layout v-if="!loadingSubmitted">
    <div class="q-pa-md row q-gutter-md justify-center">
        <q-card class="my-card justify-center" flat>
        <q-card-section>
          <h1 class="text-h6">Reset Password</h1>
          <h2 class="text-caption">Type your new password to regain access to your</h2>
        </q-card-section>
        <q-card-section v-if="!loadingSubmitted">
          <q-form
            @submit="handleSubmit"
            class="q-gutter-md"
            ref="userForm"
          >
            <q-input
              filled
              type="password"
              required
              v-model="password"
              minlength="6"
              label="Password*"
              lazy-rules
            />
            <div class="col-12 col-md-6">
              <q-btn label="Reset Password" class="full-width" size="md" :loading="loadingSubmitted" unelevated rounded type="submit" color="primary"/>
            </div>
            <q-banner v-if="error" round dense inline-actions class="text-white bg-red">
              {{error}}
              <template v-slot:action>
                <q-btn flat label="Dismiss" @click="error = ''" />
              </template>
            </q-banner>
          </q-form>
        </q-card-section>
      </q-card>
    </div>
  </q-layout>
  <div class="q-pa-md row q-gutter-md justify-center" v-else>
    <Spinner/>
  </div>
  
</template>

<script>
import {ref} from "vue";
// import useSignup from '@/composables/useSignup'
import Spinner from "@/components/Spinner"
import { inject } from 'vue'
import { useRoute } from 'vue-router'
import router from "@/router"

export default {
  name: "User_SignUp",
  components: {Spinner},
  setup(){
    //refs
    const displayName = ref('')
    const email = ref('')
    const password = ref('')
    const msg = ref(null)
    const error = ref(null)
    const userForm = ref(null)
    const loadingSubmitted = ref(false)
    const axios = inject('axios')
    const route = useRoute()
    const token = ref(null)

    // const {error, signup} = useSignup()

    const handleSubmit = async () => {
      loadingSubmitted.value = true
      axios.post(`${process.env.VUE_APP_URL}/changeForgottenPassword/token.value`, 
      {
        newPassword: password.value
      })
      .then((resp)=>{
        router.push('/user/signin')
      })
      .catch((err) => {
        loadingSubmitted.value = false
        error.value = 'An error ocurred when resetting user password. Wait a few moments and try again.'
      })
    }

    token.value = route.params.id
    
    return {displayName, email, password, handleSubmit, error, msg, loadingSubmitted}
  }
}
</script>
